import { Button, Col, Input, Row } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { ChangeEvent } from "react";
import { View, WowEntity, WowEntityCreation } from "../../../types/views";

export interface EditWowViewProps {
  view: View;
  onEntityChange: (index: number, entities: any) => void;
  onViewNameChange: (name: string) => void;
  onAddEntity: () => void;
  onDeleteEntity: (index: number) => void;
}

const EditWowView = (props: EditWowViewProps) => {
  const {
    view,
    onEntityChange,
    onViewNameChange,
    onAddEntity,
    onDeleteEntity,
  } = props;

  const handleWowEntityChange = (
    field: keyof WowEntityCreation,
    value: ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    const updatedEntity = {
      ...view.entities[index],
      [field]: value.target.value,
    };
    onEntityChange(index, updatedEntity);
  };

  return (
    <div>
      <Row>
        <Col span={12}>Name</Col>
        <Col span={12}>
          <Input
            value={view.name}
            onChange={(e) => onViewNameChange(e.target.value)}
          />
        </Col>
      </Row>
      <Row>
        <Col span={8}>Character</Col>
        <Col span={8}>Region</Col>
        <Col span={8}>Realm</Col>
      </Row>
      <hr />
      {view.entities.map((entity, i) => {
        const wowEntity = entity as WowEntity;
        return (
          <Row key={wowEntity.id}>
            <Col span={7}>
              <Input
                value={wowEntity.name}
                onChange={(e) =>
                  onEntityChange(i, {
                    ...entity,
                    name: e.target.value,
                  })
                }
              />
            </Col>
            <Col span={7}>
              <Input
                style={{ marginLeft: "6px" }}
                value={wowEntity.region}
                onChange={(e) => handleWowEntityChange("region", e, i)}
              />
            </Col>
            <Col span={7}>
              <Input
                style={{ marginLeft: "6px" }}
                value={wowEntity.realm}
                onChange={(e) => handleWowEntityChange("realm", e, i)}
              />
            </Col>
            <Col span={1} />
            <Col span={2}>
              <Button
                danger
                icon={<DeleteOutlined />}
                onClick={() => onDeleteEntity(i)}
              />
            </Col>
          </Row>
        );
      })}
      <Row>
        <Button style={{ marginTop: "5px" }} onClick={onAddEntity}>
          Add character
        </Button>
      </Row>
    </div>
  );
};

export default EditWowView;
